<template>
  <div class="component">
    <div class="body" @click.stop="expand()">
      <div :class="'image item-image default-image ' + (level.info.video ? 'has-video' : '') + ' color-' + level.info.level + ' ' + (
        (level.info.minage >= 7 || level.info.is_private) ? 'young-adults' : 'children'
        )" :style="'background-image:url(' + level.info.image + ')'">
        <div v-if="level.info.show_bjornbusen" :class="{bjorbusen: true, 'has-subtitle': level.info.sub_title_2}" :style="'background-image:url(https://static.booking.branasgruppen.se/static/img/Skidskola/skidskola-bjornbusen.png)'">
          <h2 :class="{'has-subtitle': level.info.sub_title_2}">{{level.info.sub_title_1}}<span class="smaller" v-if="level.info.sub_title_2">{{ level.info.sub_title_2 }}</span></h2>
        </div>
        <span v-if="level.info.show_badge"
          :class="'badge badge-' + ((level.info.level_virtual || '').match(/snolek$/) ? 'purple' : level.info.level)">{{ level.info.level_name }}</span>
        <div class="snow-bg" v-if="$route.name !== 'bike school overview'"></div>

        <!-- Video overlay -->
        <div :class="'video-overlay ' + (level.info.show_bjornbusen ? 'video-overlay--bottom-right' : '')" v-if="level.info.video">
          <i class="fal fa-play-circle" @click.stop="openVideo"></i>
        </div>
      </div>

      <div class="details">
        <div class="details-start">
          <p class="area-title" style="font-size:1px;">&nbsp;</p>
          <h3>{{level.info.special_title}}</h3>

          <div class="description">
            <p>{{level.info.description}}</p>
          </div>

          <div class="description" v-if="level.info.prerequisites">
            <b>{{ $t('skischool.prerequisites') }}</b>
            <p>{{ level.info.prerequisites }}</p>
          </div>
        </div>
      </div>
    </div>
    <SkiSchoolListUnitsList ref="unitList" :courses="level.courses" :info="level.info" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import SkiSchoolListUnitsList from '@/components/parts/SkiSchool/SkiSchoolListUnitsList';

export default {
  props: ['level'],
  components: {
    SkiSchoolListUnitsList,
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    expand() {
      this.$refs.unitList.isManuallyExpanded = !this.$refs.unitList.isManuallyExpanded;
    },
    openVideo() {
      let url = 'https://player.vimeo.com/video/';
      const id = this.level.info.video.match(/[0-9]+/);
      url = `${url}${id}`;

      this.openModal(['MovieModal', {
        url,
      }]);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'


.component
  margin-top space-3



.body
  background-color white
  display flex
  align-items flex-start
  shadow()
  padding space-1
  cursor pointer
  +max-mobile()
    flex-wrap: wrap
    padding-left 10px
    padding-right 10px
  p
    margin-bottom: 5px

.image
  background-color #fff
  width 215px
  height 185px
  background-size cover
  background-position center

  background-position: 50%;
  background-repeat: no-repeat;
  margin-right: 1rem;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;

  +max-mobile()
    width 100%
    height 140px

.details
  display flex
  width calc(100% - 215px)
  flex-direction: column;
  margin-left space-3
  margin-right space-3
  align-self stretch
  +max-mobile()
    width 100%
    margin-left 0
    margin-right 0
    padding-left padding-mobile
    padding-right padding-mobile
  h3
    united-heavy()
    font-size 22px
    text-transform uppercase
    margin-top 10px
    margin-bottom 3px
    +max-mobile()
      font-size: 18px

.details-start
  flex 1 0 auto
  p
    font-size: 14px
    line-height: 1.3em
    margin-bottom: 10px
  p.area-title
    color gray
    font-size 9px
    font-weight 300
    letter-spacing 0.4px
    color #474747
    margin 0 0 5px 0
    text-transform uppercase
    margin-top space-1

.description
  color gray

.features
  max-width 400px
  column-width 200px
  column-gap 0
  list-style none
  padding-left 0
  li
    padding-left 1em
    margin-bottom space-half
    &:before
      display inline-block
      content '●'
      color deep-blue
      width 1em
      margin-left -1em

.item-image
  background-size: cover
  background-position center
  background-repeat: no-repeat;
  margin-right space-2
  flex-shrink 0
  position relative
  overflow: hidden
  .snow-bg
    position: absolute;
    height: 20px
    width: 100%
    bottom: 0px
    background-image: url(https://static.booking.branasgruppen.se/static/img/Skidskola/snow.png)
    background-position: 0px 10px;
    background-repeat: repeat-x;
    background-size: 100%
    +max-tablet()
      background-size: 80%
      background-position: 0px 7px;
    +max-mobile()
      background-size: 160px
      background-position: 0px 4px;
  +max-mobile()
    height: 80px
    width: 100%
  +max-mobile()
    &.young-adults
      height: 140px
  &.color-green
    background-color rgba(85, 151, 97, 0.93)
  &.color-yellow
    background-color rgba(218, 153, 5, 0.92)
  &.color-blue
    background-color rgba(0, 77, 115, 0.92)
  &.color-red
    background-color rgba(174, 17, 22, 0.92)
  &.color-black
    background-color #262626

  .bjorbusen
    width: 100%
    height: 180px
    background-size: 40%
    background-position 50% 60%
    &.has-subtitle
      background-position center 65%
    background-repeat: no-repeat;
    +max-mobile()
      background-size 50px
      background-position: 55px 10px;
      width 100%
    h2
      color white
      padding-top 20px
      text-align: center;
      padding-left: 10px
      padding-right: 10px
      font-size: 22px
      &.has-subtitle
        font-size: 20px
        padding-top 12px
        margin-bottom: 0
      +max-mobile()
        text-align: left
        padding-left 115px
        padding-top 25px
      .smaller
        color white
        padding-top 0
        text-align: center;
        padding-left: 10px
        padding-right: 10px
        font-size: 14px
        margin-top 3px
        margin-top 0
        united-heavy()
        text-transform: uppercase;
        font-weight: 900
        display: block;
        +max-mobile()
          display: inline;

  img
    position: absolute;
    bottom -10px
    left 0
    width 100%
    +max-mobile()
      bottom -30px

  .badge
    display inline-block
    united-heavy()
    uppercase()
    font-size: size-font-badge
    color: white
    padding 6px 12px 15px 10px
    padding-bottom 0
    text-align center
    border-bottom-right-radius: 2px
    position absolute
    top 0
    left 0
    truncate()
    &.badge-green
      background-color rgba(85, 151, 97, 0.93)
    &.badge-yellow
      background-color rgba(218, 153, 5, 0.92)
    &.badge-blue
      background-color rgba(0, 77, 115, 0.92)
    &.badge-red
      background-color rgba(174, 17, 22, 0.92)
    &.badge-black
      background-color #262626
    &.badge-purple
      background-color rgba(182, 59, 126, 0.92)

.video-overlay
  text-align: center;
  position: absolute;
  background-color: rgba(0,0,0,.1);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .2s linear;
  i
    font-size: 50px;
    color: #fff;
    transition: all .2s linear;
    position: absolute;
    top: calc(50% - 25px);
    width: 100%;
    left: 0;
  &--bottom-right
    i
      bottom: 10px;
      right: 10px;
      top auto
      left auto
      width auto
      +max-mobile()
        bottom 20px
</style>



// WEBPACK FOOTER //
// SkiSchoolListPool.vue?475cf21e